import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import { followAthlete } from 'api/athlete';
import { FOLLOWING_STATUS } from 'constants/follows/following-constants';
import { useFriendsContext } from '../../../state/FriendsContext';
import {
  CLEAR_ALERT,
  ADD_ALERT,
  UPDATE_FRIEND_FOLLOWING_STATUS
} from '../../../state/friendsActions';
import { t } from '../../../utils/friendsUtils';

import styles from './InviteFriendsHeader.scss';

/* invite friends version of the fb friends modal has header with `follow all` button */
const InviteFriendsHeader = ({ sortedFriends }) => {
  const { state, dispatch, track } = useFriendsContext();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFollowAll = async () => {
    setIsProcessing(true);
    dispatch({ type: CLEAR_ALERT });

    const followableFriends = sortedFriends.filter(
      (friend) => friend.isFollowable
    );

    // followSuccess lets us break the loop if a follow attempt fails
    // same follow request as for the individual FriendEntry
    // TODO hopefully replace this with bulk follow endpoint
    let followSuccess = true;
    followableFriends.every((friend) => {
      followAthlete({
        followerId: state.currentAthlete.id,
        followingId: friend.id
      }).then((status) => {
        if (status === FOLLOWING_STATUS.error) {
          dispatch({
            type: ADD_ALERT,
            payload: {
              alert: { severity: 'error', message: t(`errors.generic`) }
            }
          });
          followSuccess = false;
        } else {
          dispatch({
            type: UPDATE_FRIEND_FOLLOWING_STATUS,
            payload: {
              id: friend.id,
              isFollowable: false,
              followingStatus: friend.approveFollowers
                ? FOLLOWING_STATUS.pending
                : FOLLOWING_STATUS.following
            }
          });
        }
      });
      return followSuccess;
    });

    track({
      element: 'follow_all_btn',
      action: 'click',
      properties: {
        current_tab: 'facebook',
        follow_all_count: followableFriends.length,
        follow_all_status: followSuccess ? 'success' : 'error'
      }
    });

    setIsProcessing(false);
  };

  return (
    <div className={styles.fbHeader}>
      <h3 className={styles.headline}>
        {t('invite_friends.friends_on_strava')}
      </h3>
      {sortedFriends.length > 0 && (
        // follow all
        <Button
          type="button"
          variant="primary"
          disabled={
            isProcessing || !sortedFriends.some((friend) => friend.isFollowable)
          }
          onClick={handleFollowAll}
        >
          {t('cta_actions.follow_all')}
        </Button>
      )}
    </div>
  );
};

InviteFriendsHeader.propTypes = {
  sortedFriends: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      picture: PropTypes.string,
      followingStatus: PropTypes.oneOf([
        FOLLOWING_STATUS.canFollow,
        FOLLOWING_STATUS.canRequest,
        FOLLOWING_STATUS.pending,
        FOLLOWING_STATUS.following
      ]),
      isFollowable: PropTypes.bool,
      approveFollowers: PropTypes.bool,
      badge: PropTypes.string,
      displayName: PropTypes.string,
      displayLocation: PropTypes.string
    })
  ).isRequired
};

export default InviteFriendsHeader;
